import { rankingItems } from '@/mocks/ranking';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热度榜单
            </h2>
            <p className="text-sm text-foreground-500 mt-1">今日最受关注的热门内容</p>
          </div>
          <div className="flex gap-2">
            {['今日', '本周', '本月'].map((tab) => (
              <button
                key={tab}
                className={`text-xs px-3 py-1.5 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  tab === '今日'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 px-5 py-3.5 border-b border-background-100 last:border-0 hover:bg-background-100/50 transition-colors cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`text-sm font-bold ${
                      item.rank === 1
                        ? 'text-accent-500'
                        : item.rank === 2
                          ? 'text-primary-500'
                          : 'text-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm text-foreground-800 font-medium truncate">
                    {item.title}
                  </span>
                  {item.tag === 'hot' && (
                    <span className="text-[10px] bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded whitespace-nowrap">
                      爆
                    </span>
                  )}
                  {item.tag === 'new' && (
                    <span className="text-[10px] bg-primary-100 text-primary-700 px-1.5 py-0.5 rounded whitespace-nowrap">
                      新
                    </span>
                  )}
                </div>
              </div>

              <div className="flex-shrink-0 text-xs text-foreground-400">
                <i className="ri-fire-line text-accent-500 mr-1"></i>
                {item.heat}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}